<template>
  <section v-if="!userIsEmpty('user')" class="settings">
    <div class="settings-wrapper">
      <h1 class="heading">
        <div class="container-mobile">{{ $t("settings.settings") }}</div>
      </h1>
      <div class="tabs container-mobile">
        <div
          v-for="(tab, key) in tabs"
          @click="toggleTabs(tabs, key)"
          class="tabs-item"
          :key="key"
          :class="{ 'tabs-current': tab.selected }"
        >
          {{ tab.text }}
        </div>
      </div>
      <div v-if="tabs.security.selected" class="info-block container-mobile">
        <Personal></Personal>
      </div>
      <div v-if="tabs.privacy.selected" class="info-block container-mobile">
        <Privacy></Privacy>
      </div>
    </div>
  </section>
  <section v-else class="no-auth">
    {{ $t("auth.noAuth") }}
    <router-link class="link" tag="a" :to="{ name: 'home' }">
      {{ $t("auth.noAuthLink") }}
    </router-link>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { toggleTabs } from "@/mixins/toggleTabs";
import Personal from "@/components/Blocks/Personal";
import Privacy from "@/components/Blocks/Privacy";

export default {
  name: "Settings",
  props: {
    i18n: Object,
  },
  components: {
    Personal,
    Privacy,
  },
  mixins: [toggleTabs],
  data() {
    return {
      tabs: {
        security: {
          text: this.$t("settings.security"),
          selected: true,
        },
        privacy: {
          text: this.$t("settings.privacy"),
          selected: false,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      userIsEmpty: "user/isEmpty",
      user: "user/fetchUser",
      userErrors: "user/errors",
    }),
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_tabs";
</style>

<style lang="scss">
@import "~@/assets/styles/pages/_settings";
</style>
